import useHttpStatus from './useHttpStatus';

export default (opts) => {
  const [res, req, fetched, progress] = useHttpStatus({
    progress: true,
    ...opts,
  });

  const onFile = (api = {}, file) => {
    if (file.length === undefined) { // single file
      const fd = new FormData();
      fd.append('file', file);

      return req({
        method: 'post',
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        data: fd,
        ...api,
      });
    }
    Array.from(file).forEach((f) => { // fileList
      const fd = new FormData();

      fd.append('file', f);

      return req({
        method: 'post',
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        data: fd,
        ...api,
      });
    });
  };

  return [res, onFile, fetched, progress];
};
